import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from '@library/components/card/Card';
import { GAME_OVERRIDE_TYPES } from '@bo-test/mock/data/simulations';
import { GameIntegerOverride } from '@bo-components/simulations/steps/StepOneBuild/GameInputs/inputs/GameIntegerOverride';
import { GameNumberOverride } from '@bo-components/simulations/steps/StepOneBuild/GameInputs/inputs/GameNumberOverride';
import type { NFLGameInputs } from '@library/types/simulations';
import { Tooltip } from '@library/components/tooltip/Tooltip';
import { YesNoOverride } from '@bo-components/simulations/steps/StepOneBuild/GameInputs/inputs/YesNoOverride';

// Skeleton card. Values will be controlled from the parent component
export const GameInputs = ({
  gameOverrides,
  onSetGameOverrides
}: {
  gameOverrides: NFLGameInputs;
  onSetGameOverrides: (
    key: keyof NFLGameInputs,
    value: number | boolean | ''
  ) => void;
}) => {
  const handleOnBlurForNumberInput = (field: keyof NFLGameInputs) => {
    if (gameOverrides[field] === '') {
      onSetGameOverrides(field, 0);
    }
  };

  return (
    <Card className="text-soClean-100">
      <CardHeader>
        <CardTitle>Game Overrides</CardTitle>
      </CardHeader>
      <CardContent className="flex justify-center gap-12">
        {GAME_OVERRIDE_TYPES.map((gameOverride) => {
          const currentValue = gameOverrides[gameOverride.value];

          return (
            <div
              key={gameOverride.value}
              className="flex w-28 flex-col items-center gap-1"
            >
              <Tooltip
                text={gameOverride.description}
                title={gameOverride.label}
              >
                <span className="font-heebo whitespace-nowrap text-xs font-medium">
                  {gameOverride.label}
                </span>
              </Tooltip>

              {gameOverride.type === 'bool' && (
                <YesNoOverride
                  currentValue={!!currentValue}
                  field={gameOverride.value}
                  onSetGameOverrides={onSetGameOverrides}
                />
              )}
              {gameOverride.type === 'integer' && (
                <GameIntegerOverride
                  currentValue={currentValue !== '' ? Number(currentValue) : ''}
                  field={gameOverride.value}
                  onBlur={handleOnBlurForNumberInput}
                  onSetGameOverrides={onSetGameOverrides}
                />
              )}
              {gameOverride.type === 'number' && (
                <GameNumberOverride
                  currentValue={currentValue !== '' ? Number(currentValue) : ''}
                  field={gameOverride.value}
                  onBlur={handleOnBlurForNumberInput}
                  onSetGameOverrides={onSetGameOverrides}
                />
              )}
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};
